// src/pages/HackathonRegistration.tsx
import HackathonRegistration from "../../components/Hackathons/HackathonRegistration";

export default function HackathonRegistrationPage() {
  return <HackathonRegistration />;
}